export default "__VITE_ASSET__DwCmY5mS__"